module.exports = __webpack_public_path__ + "img/google.b9a0fb42.png";